import { createApp } from "vue";
import App from "./App.vue";
import router from "./router";
import store from "./store";
import "bootstrap";
import "bootstrap/dist/css/bootstrap.min.css";
import "normalize.css"; //call normalize css
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome"; //from step no. 4
import { library } from "@fortawesome/fontawesome-svg-core"; //utility function from step no. 1
import { fas } from "@fortawesome/free-solid-svg-icons"; //from step no. 2
import { far } from "@fortawesome/free-regular-svg-icons"; //from step no. 3
library.add(fas, far);

createApp(App)
  .use(store)
  .component("faIcons", FontAwesomeIcon)
  .use(router)
  .mount("#app");
